/**
 * A signed-in Firebase identity that still needs its GYMing account (the date-of-birth step).
 * `createdInThisAttempt` is true only when Firebase reported the identity as new in this
 * app session's sign-in; only then may cancelling delete it (see abandonRegistration).
 * Kept in memory: after a reload nothing is known, so cancelling only signs out.
 */
export type PendingRegistration = { uid: string; createdInThisAttempt: boolean };

let pending: PendingRegistration | null = null;

export const setPendingRegistration = (value: PendingRegistration) => {
  pending = value;
};
export const getPendingRegistration = (): PendingRegistration | null => pending;
export const clearPendingRegistration = () => {
  pending = null;
};
